import { CV_PREFIX } from '@app/components/Calendars/components/CalendarView/constants';
import { DayNumber } from '@app/components/Calendars/components/DayNumber';
import type { NMonthlyCalendar } from '@app/components/Calendars/MonthlyCalendar/types';

import '@app/components/Calendars/components/MonthGrid/styles/DayHeader.desktop.scss';

export const Header: NMonthlyCalendar.DayHeader = ({
  isToday,
  isCurrentMonth,
  day,
}) => (
  <div className={`${CV_PREFIX}-day-header`}>
    <div className="flex jc-flex-end full-width title-container">
      <DayNumber
        dayNumber={day}
        isToday={isToday}
        isDisabled={!isCurrentMonth}
        alignItems="flex-end"
      />
    </div>
  </div>
);
